module.exports = "/_next/static/images/UC-9b06e34dc31b33d647c28276158b6981.png";